import { Code } from "../models/code";
import { createAuthenticationActions } from "./actions";
import { dispatchAppStateAction, getAppState } from "../../appState";

export default createAuthenticationActions({
	getExpectedPinCode: () => new Code(getAppState().settings.pinCode!),
	dispatchToAppState: dispatchAppStateAction,
});
